import React from 'react';

const TermsOfUse = () => {

    return (
        <div style={{padding: 18}}>
    <h2 align="center" style={{marginTop: 24, marginBottom: 24}}>
    <strong>Understanding Ag, LLC, Privacy Policy</strong>
    <strong></strong>
</h2>
<p>
    Last Modified: October 6, 2021
</p>
<p>
    The Understanding Ag, LLC, takes your privacy seriously, and this Privacy Policy 
    (the <b>"Policy"</b>) describes how we collect, maintain, and use any personally 
    identifiable information about you (<b>"Personal Information"</b>) in the course of 
    providing our Services. All terms used but not defined in this Policy shall 
    have the meaning given to them in the Terms of Use.

</p>
<p>
    Please read this Policy so that you can make an informed decision about using the 
    Services. If you do not agree to all the terms in this Policy, do not use the Services. 
    By registering an account to use the Services and by using the Services, you are 
    agreeing to this Policy and consent to our collection, use and disclosure of your 
    Personal Information as described in this Policy.
</p>
<p>
    <strong> </strong>
    <strong></strong>
</p>
<h3>
    <a name="_hsl2e3ce93x2"></a>
    <strong>Personal Information</strong>
</h3>
<p>
    We obtain Personal Information about you in the following ways:
</p>
<p>
    &#9679; <u>Information that you provide to us</u>. When you register 
    an account to use the Services, you provide us with information about 
    yourself, including your first and last name, address, email, phone number, 
    organization and job title. As you use the Services, there may be other 
    circumstances in which you provide us with additional information about 
    yourself, for example, taking surveys we provide about the course user 
    experience or participating in discussions in connection with a Course.

</p>
<p>
    &#9679; <u>Information that we obtain from your use of the Services</u>.
    When you use the Services, we obtain certain information about that usage, 
    including Courses that you purchase or complete, Courses you are searching 
    for or viewed, IP address or browser types and device attributes. We collect 
    this information so that we can understand how you use the Services, Courses 
    that are of interest to you and other ways that we may improve the Services 
    and our business. To the extent that we pair this usage information with your 
    Personal Information, it will be treated as Personal Information under this 
    Policy. We may also collect information with "cookies," which are small amounts 
    of data that are stored on your computer's hard drive. Most browsers will tell 
    you how to stop accepting new cookies, how to be notified when you receive a 
    new cookie and how to disable existing cookies. You can control and/or delete 
    cookies as allowed by your browser. However, please note that prohibiting the 
    use of cookies may inhibit your use of the Services.

</p>
<p>
    &#9679; <u>Information that we obtain from other sources</u>. From time to 
    time we may obtain information about you from other sources, such as providers 
    of other services where you have consented to those providers providing 
    information about you to us, or from third parties that develop information 
    about consumers.

</p>
<h3>
    <a name="_5apj86x06w7f"></a>
    <strong>Use of Personal Information</strong>
</h3>
<p>
    We use your Personal Information to provide the Services to you (including 
    providing confirmation of completion of any Courses or Certificate Programs), 
    to understand usage of the Services so we can make improvements to the Services, 
    to analyze in an effort to better understand our Services and business in 
    general and to understand your behavior and preferences so we can offer additional 
    products, services and other opportunities that we believe will be of value to you.
</p>
<h3>
    <a name="_wsoyyode9cal"></a>
    <strong>Disclosure of Personal Information</strong>
</h3>
<p>
    We may disclose your Personal Information:
</p>
<p>
    &#9679; To our affiliates that provide services to us.
</p>
<p>
    &#9679; To our service providers that help us provide the Services (e.g., payment processors, 
    instructors, etc.). However, we will share Personal Information with such service providers 
    only if they agree to maintain the confidentiality of your Personal Information and to use 
    your Personal Information only in connection with providing the Services and other services 
    to us. These other entities may use and disclose information as provided in this Policy.
</p>
<p>
    &#9679; If compelled to in connection with a legal or regulatory proceeding, or in connection 
    with enforcing our rights or defending ourselves in a legal or regulatory process.
</p>
<p>
    &#9679; If we obtain your consent to disclose your Personal Information to a third party, in 
    which case we will limit our disclosure and the use of your Personal Information only to the 
    purposes for which we obtain your consent. If we disclose your Personal Information to a third 
    party with your consent, then your Personal Information will become subject to the privacy policy 
    or other privacy commitments, if any, of that third party. For example, we may enable you to post 
    Personal Information to a social media account, in which case that Personal Information will become 
    subject to the privacy policy of that social media platform. It is your responsibility to understand 
    the third party's privacy policy or other privacy commitments.
</p>
<h3>
    <a name="_dlnzccc5ilad"></a>
    <strong>Retention of Personal Information</strong>
</h3>
<p>
    We will retain your Personal Information for so long as we believe necessary to meet our business needs 
    and to comply with applicable legal and regulatory requirements.
</p>
<h3>
    <a name="_4jfckp97cz19"></a>
    <strong>Non-Personal Information</strong>
</h3>
<p>
    We may also share information or data in a form that cannot be used to uniquely identify or contact 
    an individual person. We may collect, use, transfer and disclose this non-personal information for 
    any purposes. Non-personal information that we collect may include information regarding your activities 
    on the Services, which may be aggregated and used to help us provide more useful information to our users 
    or sponsors and to understand which parts of the Services are of most interest.

</p>
<h3>
    <a name="_ncf2st931e2"></a>
    <strong>Access to Personal Information</strong>
</h3>
<p>
    We limit access to your Personal Information to people and entities that
    have a need to use your information for our business purposes.
</p>
<p>
    We limit access to your Personal Information to people and entities that have a need to use your information 
    for our business purposes.
    You may access some items of Personal Information through your account profile, as well as change or correct 
    those items of Personal Information through your account profile. You may request access to additional 
    Personal Information that is not available via your account profile, or request to correct, amend or 
    delete any Personal Information that is inaccurate or incomplete, by contacting us through our contact 
    information, below. However, please note that we may need to retain certain Personal Information for 
    our own business records.

</p>
<h3>
    <a name="_r0lfv1cnlm7"></a>
    <strong>Data Security</strong>
</h3>
<p>
    We have implemented measures designed to secure your Personal Information. However, 
    no data transmission over the Internet or information storage technology can be 
    guaranteed to be 100% secure.
</p>
<h3>
    <a name="_shjht212sq1s"></a>
    <strong>Transfer of Personal Information</strong>
</h3>
<p>
    We reserve the right to transfer all Personal Information in our possession to a 
    successor organization in connection with a merger, acquisition, bankruptcy or other 
    sale of all or a portion of our assets. Subject to legal requirements, you will be 
    notified via email and/or a prominent notice on the Website of any change in ownership 
    or uses of your Personal Information, as well as any choices you may have regarding 
    your Personal Information.
</p>
<h3>
    <a name="_qb2t74dqq8l9"></a>
    <strong>No Use by Children</strong>
</h3>
<p>
    The Services are not intended for use by children under the age of 13. If you become 
    aware that a child under the age of 13 has provided us with personal information 
    online, we ask that a parent or guardian please contact us.
</p>
<h3>
    <a name="_y7khzjj8vdiy"></a>
    <strong>International &amp; Nevada Users</strong>
</h3>
<p>
    The Understanding Ag, LLC, is based in the United States. The Services are intended 
    for use primarily by persons located in the United States. We make no claims that 
    the Services are accessible or appropriate outside of the United States. Access to 
    the Services may not be legal by certain persons or in certain countries. If you 
    access our Website or Services from outside the United States, you do so on your own 
    initiative, at your sole risk, and you are responsible for compliance with all 
    applicable laws.
</p>
<p>
    Nevada Opt Out Of Sale Of Data
</p>
<p>
    If you are a Nevada resident, you may have certain rights regarding the sale of personal 
    information. Nevada residents may opt out of the future sale of their information to a 
    third party so that they may license or sell information by or by emailing us at: 
    support@regenagonline.com and requesting us to not sell your personal data.
</p>
<p>
    European Union General Data Protection Regulation (EU) (GDPR)
</p>
<p>
    As a person covered under EU privacy laws, you may have broader protections than those 
    under U.S. Law. As part of your use of the products, you affirmatively consent to the 
    processing and storage of your personal information in the United States including the 
    processing and storing of your personal information in the United States for the purposes 
    of processing payments and tracking individual use of the products. By using the products 
    and visiting the site, you acknowledge that you understand and agree that the United 
    States may not have the same level of protections for your personal information that 
    exist in your country of residence, and you nonetheless consent to the processing and 
    storage of your personal information in the United states.

</p>
<p>
    You may also have the right to complain to authorities in the EU which regulate personal 
    privacy data protection, but before you do that we encourage you to reach us on our website 
    at <a href='https://www.understandingag.com/'>www.understandingag.com</a> and our email address at 
    support@regenagonline.com.
</p>
<p>
    Wherever you access our Services, you understand and acknowledge that we may transfer, 
    process and store information about you in the United States and other countries. 
    By providing us with your information, you consent to the transfer to, and to the 
    processing and storage of your information in, countries outside of your country of 
    residence, which may have different data protection laws than those in the country 
    in which you reside.
</p>
<h3>
    <a name="_vv7ike9s6o0e"></a>
    <strong>Notice of Changes</strong>
</h3>
<p>
    Your access to and use of the Services is subject to this Privacy Policy and our 
    Terms of Use. Our business continues to develop and evolve and this Privacy Policy 
    and our Terms of Use will accordingly change from time to time. We will modify this 
    Policy if our privacy practices change. We will notify you of such changes by posting 
    the modified version on our Website and indicating the date it was last modified, 
    and, if the changes are significant, we will provide a more prominent notice 
    (including by email in certain instances). The date this Policy was last modified 
    is at the top of this page. Please periodically review this Policy so that you are 
    familiar with the current Policy and aware of any changes.
</p>
<h3>
    <a name="_oe01m3551ip0"></a>
    <strong>Contact for Questions or Complaints</strong>
</h3>
<p>
    If you have any questions, comments or concerns about this Policy, please
    contact us by email at support@regenagonline.com, or by phone at 256-996-3142.
</p>
<p>
    You may also reach us by mail to the following address:
</p>
<p>
    Understanding Ag, LLC,
    <br/>
    1908 Spring Drive NW
    <br/>
    Fort Payne AL 35968
</p>
        </div>
    );
};


export default TermsOfUse;